// Simple platform detection
export const isMac = () => {
    return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
};

export const isLinux = () => {
    return navigator.platform.toUpperCase().indexOf('LINUX') >= 0;
};

export const isWindows = () => {
    return navigator.platform.toUpperCase().indexOf('WIN') >= 0;
};